/**
 * Extrai os scalar fields normalizados da resposta do SP `verificarEncomenda`,
 * cobrindo as diferentes nomeclaturas usadas entre o endpoint MY
 * (`/api/my/shop/checkout/verify`) e o CRM (`/api/encomendas/verify`).
 *
 * O SP devolve o mesmo shape — só o nome de algumas keys varia (PascalCase vs
 * camelCase). Centralizamos aqui para que o resto da app só lide com nomes
 * normalizados.
 *
 * @param {object|null} spResult primeira linha do array `data` retornado pelo SP
 * @param {{vouchers:number,credits:number}} [fallbackBalances] saldos para
 *   fallback quando o SP omite limites (acontece quando ainda não há dados
 *   suficientes para calcular).
 * @returns {object} scalar fields normalizados
 */
export function extractVerifyScalars(spResult, fallbackBalances = { vouchers: 0, credits: 0 }) {
  const sp = spResult || {};
  const num = (v) => (v == null ? null : Number(v));
  return {
    raw: sp,
    total: num(sp.Total ?? sp.PrecoFinal),
    subtotal: num(sp.Subtotal ?? sp.SubTotal),
    portes: num(sp.Portes ?? sp.CustoTransporte),
    iva: num(sp.Iva ?? sp.IvaTotal),
    descontos: num(sp.Descontos ?? sp.DescontoTotal),
    valesPermitidos: Number(sp.ValesPermitidos ?? sp.valesPermitidos ?? fallbackBalances.vouchers ?? 0),
    valesExistentes: Number(sp.VouchersExistentes ?? fallbackBalances.vouchers ?? 0),
    creditosPermitidos: Number(sp.CreditosPermitidos ?? sp.creditosPermitidos ?? fallbackBalances.credits ?? 0),
    creditosExistentes: Number(sp.CreditosExistentes ?? fallbackBalances.credits ?? 0),
    descontoVale: Number(sp.Desconto_Vale ?? sp.vouchers ?? 0),
    descontoCreditos: Number(sp.Desconto_Creditos ?? sp.credits ?? 0),
    valorDescontoCP: Number(sp.ValorDescontoCP ?? 0),
    chavePromo: (sp.ChaveCodigoPromocional || '').toString(),
    idPortes: sp.ID_Portes ?? '',
    temProdutosFisicos: Number(sp.TemProdutosFisicos ?? 0) === 1,
    tipoTransporteExterno: sp.TipoTransporteExterno ?? null, // 'S' | 'N' | null
    produtosTodosGratuitos: sp.ProdutosTodosGratuitos === true,
    encomendaGratuita: Number(sp.EncomendaGratuita ?? 0) === 1,
    mensagemErro: (sp.MensagemErro || sp.Mensagem_Erro || '').toString().trim(),
  };
}
